// extracted by mini-css-extract-plugin
export default {"mCard":"Ps-z","image":"Qs-z","imageNoBackground":"Rs-z","imageHasCategory":"Ss-z","fullWidth":"Ts-z"};